import axios from 'axios';
import { print } from 'graphql/language/printer';

const instance = axios.create({
  baseURL: process.env.REACT_APP_BOT_WEB_API_URL,
  // headers: {
  //   'x-hasura-admin-secret': process.env.REACT_APP_BOT_WEB_API_SECRET,
  // },
});

const api = async (data, options) => {
  const customOption = {};
  if (options?.req) {
    const session = options?.req?.body?.session_variables;

    if (session) {
      const headers = {
        'x-hasura-user-id': session['x-hasura-user-id'] || null,
        'x-hasura-owner-id': session['x-hasura-owner-id'] || null,
      };
      if (options.useRole) {
        headers['x-hasura-role'] = session['x-hasura-role'] || 'admin';
      }
      customOption.headers = { ...options.headers, ...headers };
    }
  }
  if (typeof data.query !== 'string') {
    // eslint-disable-next-line no-param-reassign
    data.query = print(data.query);
  }

  const apiResult = await instance
    .post('', data, { ...options, ...customOption })
    .then((res) => res.data);

  if (apiResult.errors) {
    console.log(JSON.stringify({
      data,
      trace: apiResult.errors,
    }, null, 2));

    throw new Error(
      apiResult
        .errors
        .map((error) => error.message)
        .join(' | '),
    );
  }

  return apiResult;
};

export default api;
